import {
  collection,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  startAfter,
} from "firebase/firestore";
import React, { useState, useEffect } from "react";
import { MdContentCopy } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Spinner from "../Components/Spinner/Spinner";
import Spinner2 from "../Components/Spinner/Spinner2";
import useStore from "../Store/useStore";
import moment from "moment";

const BrandsList = () => {
  const { brandsList, setBrandsList, setNotify } = useStore();
  const [loading, setLoading] = useState(!brandsList?.data?.length);
  const [loadingMore, setLoadingMore] = useState(false);
  const db = getFirestore();
  const navigate = useNavigate();

  const getLists = async (fn) => {
    try {
      fn(true);
      let q = query(collection(db, "brandsAnalysis"), orderBy("creationDate", "desc"), limit(12));
      if (brandsList?.lastVisible) {
        q = query(
          collection(db, "brandsAnalysis"),
          orderBy("creationDate", "desc"),
          startAfter(brandsList?.lastVisible),
          limit(12)
        );
      }
      const listsResult = await getDocs(q);
      const listsData = listsResult.docs.map((item) => ({ ...item.data(), id: item.id }));
      setBrandsList((prev) => ({
        data: [...prev?.data, ...listsData],
        lastVisible: listsData.length === 12 ? listsResult.docs.at(-1) : false,
      }));
      fn(false);
    } catch (err) {
      fn(false);
    }
  };

  useEffect(() => {
    if (!brandsList?.data?.length) {
      getLists(setLoading);
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen r-box pt-20">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="min-h-screen py-10 r-box">
      {brandsList?.data?.length > 0 ? (
        <div className="w-fit max-w-full mt-8 bg-gray-200/60 rounded-md p-5 overflow-x-auto mx-auto">
          <div className="min-w-[1020px] bg-white p-5 rounded-md grid grid-cols-[50px_200px_minmax(250px,_1fr)_100px_110px_120px_30px] gap-5 items-center text-sm">
            <span />
            <p>Brand</p>
            <p>Campaign name</p>
            <p>Budget</p>
            <p>Status</p>
            <p>Created on</p>
          </div>
          {brandsList?.data?.map((item, index) => (
            <div
              onClick={() => navigate(`/brandslist/${item?.id}`)}
              key={item?.id}
              className="min-w-[1020px] bg-white p-5 rounded-md mt-5 grid grid-cols-[50px_200px_minmax(250px,_1fr)_100px_110px_120px_30px] cursor-pointer gap-5 items-center"
            >
              <p className="">{index + 1}</p>
              <div className="flex items-center gap-3">
                <img
                  loading="lazy"
                  src={item?.brandImageUrl}
                  alt=""
                  className="w-10 aspect-square rounded-full object-cover object-center"
                />
                <p>{item?.brandName}</p>
              </div>
              <p className="line-clamp-1">{item?.campaignName}</p>
              <p>
                <span className="inr">{item?.currency} </span>
                {item?.budget}
              </p>
              <div className="flex items-center justify-start gap-2">
                <div
                  className={`w-2 aspect-square rounded-full ${
                    item?.status?.toLowerCase() === "live"
                      ? "bg-green-400"
                      : item?.status?.toLowerCase() === "lead"
                      ? "bg-red-400"
                      : "bg-gray-400"
                  }`}
                />
                <p className="text-sm">{item?.status}</p>
              </div>
              <p>{moment.unix(item?.creationDate).format("DD MMM YYYY")}</p>
              <MdContentCopy
                onClick={(e) => {
                  e.stopPropagation();
                  window.navigator.clipboard.writeText(item?.link || "");
                  setNotify({ status: true, message: "Link copied successfully" });
                }}
                className="text-xl"
              />
            </div>
          ))}
        </div>
      ) : (
        <p className="mt-8 text-center">No list found</p>
      )}
      {brandsList?.lastVisible && !loadingMore && !loading && (
        <button
          onClick={() => getLists(setLoadingMore)}
          className="bg-black w-40 h-11 rounded-full text-white font-medium mx-auto block mt-10"
        >
          Load more
        </button>
      )}
      {loadingMore && (
        <div className="w-fit mx-auto mt-10">
          <Spinner2 />
        </div>
      )}
    </div>
  );
};
export default BrandsList;
